import type React from 'react'

import { ImageSize, type Image as ImageType } from '@frontend/libs/types/media'
import placeholder from '@images/placeholder-wide.jpg'
import { Image } from '@nextui-org/react'
import { memo } from 'react'

interface FigureImageProps {
  image: ImageType
}

export const FigureImage = memo(
  ({ image }: Readonly<FigureImageProps>): React.JSX.Element => {
    return (
      <figure className="relative aspect-[3/4] h-full w-full">
        <Image
          alt={image.alt}
          className="h-full w-full object-cover object-center"
          fallbackSrc={placeholder}
          removeWrapper
          src={image.sizes[ImageSize.Large] || image.src}
          srcSet={image?.srcset ? image.srcset : undefined}
        />
      </figure>
    )
  },
)

FigureImage.displayName = 'FigureImage'

export default FigureImage
